import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


class Cards extends Component {

    constructor(element) {


        super(element);
        this.element = element
        this.el = $(element)

        this.ref = {
            card: []
        }
    }

    mount() {
        

       _each(this.ref.card, (item, index) => {
           ScrollTrigger.create({
               trigger: item,
               start: "top bottom",
               onEnter: ({
                   progress,
                   direction,
                   isActive
               }) => {
                   item.classList.add("inview")
               },
               onLeaveBack: ({
                   progress,
                   direction,
                   isActive
               }) => {
                   item.classList.remove("inview")
               }
           });
       })

    }




  

    unmount() {
        
    }


}

module.exports = Cards
